import React, { useContext } from 'react';
import { navigate } from 'gatsby';
import { LanguageContext } from '../../../providers';
import { jsx as ___EmotionJSX } from "@emotion/react";
const buildPath = (path, lang) => {
  lang = lang === 'de' ? '' : lang;
  if (path.includes('/en/')) {
    return path.replace('/en/', `/${lang}/`);
  } else if (path.includes('/fr/')) {
    return path.replace('/fr/', `/${lang}/`);
  } else {
    return `/${lang}${path}`;
  }
};
const LanguageToggler = _ref => {
  let {
    location
  } = _ref;
  const {
    setCurrentLanguage,
    availableLanguages,
    language
  } = useContext(LanguageContext);
  function onChange(event) {
    event.preventDefault();
    const lang = event.target.value;
    setCurrentLanguage(lang);
    navigate(buildPath(location.pathname, lang));
  }
  if (availableLanguages.length > 1) {
    return ___EmotionJSX("select", {
      id: "lang",
      onBlur: onChange,
      value: language
    }, availableLanguages.map(language => ___EmotionJSX("option", {
      key: language,
      value: language
    }, language)));
  } else {
    return null;
  }
};
export default LanguageToggler;